import { Action, ActionReducer, createReducer, on } from '@ngrx/store';

import { InstallationsMigrationActions } from './installations-migration.actions';
import { MigrationStatus } from './installations-migration.model';
import { InstallationsMigrationState } from './installations-migration.state';

export const initInstallationsMigrationState: InstallationsMigrationState = {
  customerNumber: undefined,
  newCustomerNumber: undefined,
  customerCompanyName: undefined,
  newCustomerCompanyName: undefined,
  installations: [],
  cursor: undefined,
  installationsToMigrate: [],
  isCustomerNumbersVerified: false,
  isData: false,
  loading: false,
  loaded: false,
  error: null,
  migrationStatus: MigrationStatus.USER_ACTION,
};

export const installationsMigrationReducer: ActionReducer<
  InstallationsMigrationState,
  Action
> = createReducer(
  initInstallationsMigrationState,

  on(
    InstallationsMigrationActions.setCustomerNumber,
    (state, { customerNumber }): InstallationsMigrationState => ({
      ...state,
      isCustomerNumbersVerified: false,
      customerNumber,
    })
  ),

  on(
    InstallationsMigrationActions.setNewCustomerNumber,
    (state, { newCustomerNumber }): InstallationsMigrationState => ({
      ...state,
      isCustomerNumbersVerified: false,
      newCustomerNumber,
    })
  ),

  on(
    InstallationsMigrationActions.setInstallationsToMigrate,
    (state, { installationsToMigrate }): InstallationsMigrationState => ({
      ...state,
      isCustomerNumbersVerified: false,
      installationsToMigrate,
    })
  ),

  on(
    InstallationsMigrationActions.getCustomerCompanyNames,
    (state): InstallationsMigrationState => ({
      ...state,
      isCustomerNumbersVerified: false,
      loading: true,
      loaded: false,
      error: null,
    })
  ),

  on(
    InstallationsMigrationActions.getCustomerCompanyNamesSuccess,
    (state, { customerCompanyName, newCustomerCompanyName }): InstallationsMigrationState => ({
      ...state,
      customerCompanyName,
      newCustomerCompanyName,
      isCustomerNumbersVerified: true,
      loading: false,
      loaded: true,
      error: null,
    })
  ),

  on(
    InstallationsMigrationActions.getCustomerCompanyNamesError,
    (state): InstallationsMigrationState => ({
      ...state,
      customerCompanyName: null,
      newCustomerCompanyName: null,
      isCustomerNumbersVerified: true,
      loading: false,
      loaded: true,
    })
  ),

  on(
    InstallationsMigrationActions.listCompanyCustomerInstallations,
    (state): InstallationsMigrationState => ({
      ...state,
      isCustomerNumbersVerified: false,
      loading: true,
      error: null,
      cursor: null,
      migrationStatus: MigrationStatus.USER_ACTION,
    })
  ),

  on(
    InstallationsMigrationActions.listCompanyCustomerInstallationsSuccess,
    (state, { installations, cursor }): InstallationsMigrationState => {
      const allInstallations = [...state.installations, ...installations];

      return {
        ...state,
        cursor,
        installations: allInstallations,
        isData: !!allInstallations.length,
        isCustomerNumbersVerified: false,
        loading: false,
        loaded: true,
      };
    }
  ),

  on(
    InstallationsMigrationActions.migrateInstallations,
    (state): InstallationsMigrationState => ({
      ...state,
      migrationStatus: MigrationStatus.IN_PROGRESS,
    })
  ),

  on(
    InstallationsMigrationActions.migrateInstallationsSuccess,
    (state): InstallationsMigrationState => ({
      ...state,
      migrationStatus: MigrationStatus.SUCCESS,
    })
  ),

  on(
    InstallationsMigrationActions.migrateInstallationsError,
    (state): InstallationsMigrationState => ({
      ...state,
      installations: [],
      migrationStatus: MigrationStatus.ERROR,
    })
  ),

  on(
    InstallationsMigrationActions.clearCachedInstallations,
    (state): InstallationsMigrationState => ({
      ...state,
      installations: [],
      installationsToMigrate: [],
    })
  ),

  on(
    InstallationsMigrationActions.clearLoadedInstallations,
    (state): InstallationsMigrationState => ({
      ...state,
      installations: [],
    })
  ),

  on(
    InstallationsMigrationActions.clearCachedData,
    (): InstallationsMigrationState => ({
      ...initInstallationsMigrationState,
    })
  )
);
